import { render } from "./FeaturedRive.vue?vue&type=template&id=6d1073a4"
import script from "./FeaturedRive.vue?vue&type=script&lang=js"
export * from "./FeaturedRive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/FeaturedRive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d1073a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d1073a4', __exports__)) {
    api.reload('6d1073a4', __exports__)
  }
  
  module.hot.accept("./FeaturedRive.vue?vue&type=template&id=6d1073a4", () => {
    api.rerender('6d1073a4', render)
  })

}


export default __exports__